/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/home-sections.
 * Only visible sections are served, already in display order.
 */

import type { CmsHomeSection } from '@/content/nav-types'

export type { CmsHomeSection }

export const cmsHomeSections: CmsHomeSection[] = [
  {
    "section_key": "hero",
    "sort_order": 10,
    "settings": {}
  },
  {
    "section_key": "products",
    "sort_order": 30,
    "settings": {}
  },
  {
    "section_key": "smartcindy",
    "sort_order": 40,
    "settings": {}
  },
  {
    "section_key": "harbour",
    "sort_order": 50,
    "settings": {}
  },
  {
    "section_key": "magazine",
    "sort_order": 80,
    "settings": {}
  },
  {
    "section_key": "lectures",
    "sort_order": 90,
    "settings": {
      "limit": 3,
      "audience": ""
    }
  },
  {
    "section_key": "news",
    "sort_order": 100,
    "settings": {
      "limit": 3
    }
  }
]
